import { useState, useEffect, FC } from 'react'
import { IonInput, IonItem, IonLabel } from '@ionic/react'
import { Auth } from 'aws-amplify'
import { useAuthenticator } from '@aws-amplify/ui-react'
import useDebounce from '../../components/hooks/useDebounce'
import { CurrentUserService } from '../../components/services/CurrentUserService'
import { connect } from '../../data'
import { setNet } from '../../data/user/user.actions'

interface OwnProps {
  required?: boolean
  onTbnChange?: Function
}
interface StateProps {}
interface DispatchProps {
  setNet: typeof setNet
}
interface FamilyNameProps extends OwnProps, StateProps, DispatchProps {}

const FamilyName: FC<FamilyNameProps> = ({ required = false, onTbnChange, setNet }) => {
  const { user } = useAuthenticator((context) => [context.user])
  const [familyName, setFamilyName] = useState<string | undefined>(user?.attributes?.family_name)
  const debounced = useDebounce(familyName, 500)

  const updateFamilyName = async (family_name?: string) => {
    setNet(true)
    try {
      const user = await Auth.currentAuthenticatedUser()
      if (user?.attributes?.family_name !== family_name) {
        const res = await Auth.updateUserAttributes(user, {
          family_name: family_name?.trim(),
        })
        if (res === 'SUCCESS') {
          try {
            CurrentUserService.Instance?.updateCurrentFamilyName(familyName?.trim())
          } catch (ignore) {}
        }
      }
    } catch (ignore) {}
    setNet(false)
  }

  useEffect(() => {
    updateFamilyName(debounced)
  }, [debounced]) // eslint-disable-line

  useEffect(() => {
    if (!!onTbnChange) {
      onTbnChange(familyName)
    }
  }, [familyName]) // eslint-disable-line

  useEffect(() => {
    try {
      CurrentUserService.Instance?.currentUser().catch(() => {})
    } catch (ignore) {}
    if (!!user?.attributes?.family_name && !familyName) {
      setFamilyName(user?.attributes?.family_name)
    }
  }, []) // eslint-disable-line

  return (
    <IonItem>
      <IonLabel position='stacked' className={required ? 'required' : ''}>
        Surname
      </IonLabel>
      <IonInput
        value={familyName}
        defaultValue={user?.attributes?.family_name}
        placeholder={'Surname'}
        onIonChange={(e: any) => setFamilyName(e.detail.value)}
      />
    </IonItem>
  )
}

export default connect<OwnProps, StateProps, DispatchProps>({
  mapDispatchToProps: {
    setNet,
  },
  component: FamilyName,
})
